import { 
  StatusAngefertigtIcon, 
  StatusSendeIcon, 
  StatusInterviewIcon, 
  StatusZusageIcon, 
  StatusAbsageIcon 
} from './FlowIcons';

export const STATUS_OPTIONEN = [
  { key: 'unterlagen_angefertigt', label: 'Angefertigt', color: '#7C6F64', Icon: StatusAngefertigtIcon },
  { key: 'abgeschickt',           label: 'Abgeschickt', color: '#0284c7', Icon: StatusSendeIcon },
  { key: 'kennenlerngespraech',   label: 'Interview',   color: '#d97706', Icon: StatusInterviewIcon },
  { key: 'zusage',                label: 'Zusage!',     color: '#059669', Icon: StatusZusageIcon },
  { key: 'absage',                label: 'Absage',      color: '#dc2626', Icon: StatusAbsageIcon },
];
